<template>
  <el-row
    :gutter="24"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <el-col
      :span="14"
      :offset="5"
      :xs="{span:18, offset: 3}"
    >
      <el-tabs v-model="activeTab">
        <el-tab-pane
          label="Driver License"
          name="driverLicense"
        >
          <DriverLicense
            v-if="user.address"
            :user.sync="user"
            @screenLoading="changeScreenLoading"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Insurance"
          name="insurance"
        >
          <Insurance
            v-if="user.patientNumber"
            :user.sync="user"
            @screenLoading="changeScreenLoading"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="$route.params.tab === 'FibroidAuthObtainMedicalRecords'"
          label="Sign documents"
          name="FibroidAuthObtainMedicalRecords"
        >
          <SignDocuments
            v-if="user.patientNumber"
            :user.sync="user"
            :active-tab="activeTab"
            @screenLoading="changeScreenLoading"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="$route.params.tab === 'FibroidReviewDocuments'"
          label="Upload documents"
          name="FibroidReviewDocuments"
        >
          <UploadDocuments
            v-if="user.patientNumber"
            :user.sync="user"
            @screenLoading="changeScreenLoading"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Profile"
          name="profile"
        >
          <Profile
            v-if="user.patientNumber"
            :user.sync="user"
            @screenLoading="changeScreenLoading"
          />
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
import Profile from './tabs/Profile';
import DriverLicense from './tabs/DriverLicense';
import Insurance from './tabs/Insurance';
import SignDocuments from './tabs/SignDocuments';
import UploadDocuments from './tabs/UploadDocuments';

export default {
  name: 'UpdateInfo',
  components: {
    DriverLicense,
    Profile,
    Insurance,
    SignDocuments,
    UploadDocuments
  },
  data: function () {
    return {
      activeTab: this.$route.params.tab || 'driverLicense',
      fullscreenLoading: false,
      user: {}
    };
  },
  created () {
    this.getPatientByNumber(this.$route.params.patientNumber);
  },
  methods: {
    getPatientByNumber (patientNumber = '') {
      this.fullscreenLoading = true;
      return this.$axios('/Patient/GetPatientByPatientNumber', {
        method: 'GET',
        params: {
          patientNumber: patientNumber
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.user = response.data.data;
        } else {
          this.fullscreenLoading = false;
          this.$message({
            showClose: true,
            message: 'Oops, something went wrong!',
            type: 'error'
          });
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    changeScreenLoading (val = false) {
      this.fullscreenLoading = val;
    }
  }
};
</script>
